import React from "react";
import { FaEnvelope, FaPhoneAlt, FaYoutube } from "react-icons/fa";
import "../styles/contacto.css";

export const Contactanos = () => {

 return (

    <main className="carta">

      <section className="carta-header">

        <div className="carta-header__wrap">

          <h1 className="carta-header__title">

           COTACTANOS

          </h1>

          <p className="carta-header__subtitle">

            Explora nuestro sistema y mejora tus procesos

          </p>
          <div className="contactanos">

  <h2 className="contactanos__titulo">
    Contáctanos
  </h2>

  <div className="contactanos__items">

    {/* CORREO */}
    <div className="contactanos__item">
      <FaEnvelope className="contactanos__icon gmail" />

      <div>
        <h4>Correo Electrónico</h4>
        <a href="mailto:contacto@pertisoft.com">
          sandoya01@gmail.com
        </a>
      </div>
    </div>

    {/* TELÉFONO */}
    <div className="contactanos__item">
      <FaPhoneAlt className="contactanos__icon telefono" />

      <div>
        <h4>Teléfono</h4>
        <a href="tel:+51999999999">
          +51 969 849 187
        </a>
      </div>
    </div>

    {/* YOUTUBE */}
    <div className="contactanos__item">
      <FaYoutube className="contactanos__icon youtube" />

      <div>
        <h4>Canal de YouTube</h4>
        <a   href="https://www.youtube.com/watch?v=_pLcddi4kpk&t=216s"  target="_blank"     rel="noreferrer"  >
          Ver Canal
        </a>
      </div>
    </div>

  </div>

</div>

        </div>

      </section>

 </main>

  );
};
